<template>
	<v-dialog v-model="dialog" max-width="800">
		<template v-slot:activator="{ on }">
			<v-col md="6" sm="12">
				<v-btn @click="loadUser('', 'save')" color="primary" v-on="on">
					<v-icon left>mdi-plus</v-icon>
					Novo Usuario
				</v-btn>
			</v-col>
		</template>
		<v-card>
			<v-card-title primary-title>
				{{ titleForm }}
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-form>
						<v-row>
							<v-col md="6">
								<v-text-field v-model="usuario.nome" label="Nome" required :disabled="mode === 'remove'"
								dense></v-text-field>
							</v-col>
							<v-col md="3">
								<v-text-field type="text" v-model="usuario.usuario" label="Usuário" required
								:disabled="mode === 'remove'" dense></v-text-field>
							</v-col>
							<v-col md="3">
								<v-text-field type="date" label="Nascimento" v-model="usuario.nascimento"
								:disabled="mode === 'remove'" dense></v-text-field>
							</v-col>
						</v-row>
						<v-row v-show="mode === 'save'">
							<v-col md="4">
								<v-text-field type="text" v-model="usuario.email" label="Email" required
								:disabled="mode === 'remove'" dense></v-text-field>
							</v-col>
							<v-col md="4" sm="5">
								<v-text-field id="usuario-cpf" label="CPF" v-model="usuario.cpf" type="text" size="sm"
								:disabled="mode === 'remove'" v-mask="['###.###.###-##']"
								:error-messages="validationCpf[0].msg" :color="validationCpf[0].color"
								dense></v-text-field>
							</v-col>
							<v-col md="4">
								<v-text-field v-model="usuario.contato" label="Celular" v-mask="['(##)#####-####']"
								required dense></v-text-field>
							</v-col>
							<v-row>
								<v-col>
									<v-select v-model="usuario.tipo" :items="cargos" label="Função" dense
									:disabled="user.id === usuario.id_func"></v-select>
								</v-col>
								<v-col>
									<v-text-field size="sm" :disabled="mode === 'remove'" v-model="usuario.cod_pdv"
									label="Código PDV" dense></v-text-field>
								</v-col>
								<v-col>
									<v-text-field size="sm" :disabled="mode === 'remove'" v-model="usuario.cod_vendedor"
									label="Código Colaborador" dense></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col md="4">
									<v-select
									:items="cargahoraria"
									label="Carga Horária"
									v-model="tipoCargaHoraria"
									dense
									@change="onChangeCargaHoraria"
									></v-select>
								</v-col>
								<v-col md="4" v-if="tipoCargaHoraria === 'manual'">
									<v-text-field
									label="Horas manuais"
									v-model="cargaHorariaManual"
									type="number"
									min="5"
									step="1"
									:rules="[validarCargaHorariaManual]"
									dense
									></v-text-field>
								</v-col>
								<v-col md="4">
									<v-text-field
										type="date"
										label="Vigencia da carga"
										v-model="usuario.carga_horaria_vigencia_inicio"
										dense
									></v-text-field>
								</v-col>
								<v-col>
									<v-text-field label="Salário" v-model="usuario.salario" v-mask="['####,##']"
									dense></v-text-field>
								</v-col>
								<v-col>
									<v-switch v-model="usuario.externo" label="Usuário Externo" 
									:disabled="mode === 'remove'" dense></v-switch>
								</v-col>
								<v-col v-if="usuario.externo">
									<v-switch v-model="usuario.acesso_desktop" label="Permitir Acesso Desktop" 
									:disabled="mode === 'remove'" dense></v-switch>
								</v-col>
							</v-row>
						</v-row>
						<v-row v-show="mode === 'save' && usuario.id_user == undefined">
							<v-col>
								<v-text-field type="password" v-model="usuario.senha" label="Senha" required
								dense></v-text-field>
							</v-col>
							<v-col>
								<v-text-field type="password" v-model="usuario.confirmSenha" label="Confirmar Senha"
								required dense></v-text-field>
							</v-col>
						</v-row>
						<v-card-actions>
							<v-row>
								<v-col>
									<v-btn color="primary" class="mr-1" v-if="mode === 'save'" @click="save"
									dense>salvar</v-btn>
									<v-btn color="error" class="mr-1" v-else @click="remove" dense>exluir</v-btn>
									<v-btn color="grey" class="ml-1" dark @click="reset" dense>cancelar</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-form>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import Bus from '@/barramento'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { cpf } from "cpf-cnpj-validator";

export default {
	name: 'DialogUser',
	props: {
		data: {},
		title: String,
		modo: String,
	},
	mixins: [validationMixin],
	validations: {
		usuario: {
			cpf: { required },
		},
	},
	data() {
		return {
			mode: this.modo,
			usuario: {},
			dialog: false,
			titleForm: '',
			validEmail: [this.isEmailValid],
			reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
			cargahoraria: [
				{ text: 'Integral', value: 'integral' },
				{ text: 'Meio Período', value: 'meio_periodo' },
				{ text: 'Personalizada', value: 'manual' }
				],
			tipoCargaHoraria: 'integral',
			cargaHorariaManual: null,
			cargos: []
		}
	},
	computed: {
		...mapState(['user']),
		validationCpf() {
			const errors = [{ msg: "", color: "error", status: true }];
			if (this.usuario.cpf) {
				cpf.isValid(this.usuario.cpf)
				? errors[0] = { msg: '', color: 'success', status: false } : errors[0] = { msg: "CPF inválido!", color: 'error', status: true };
			}
			if (this.cpf) {
				cpf.isValid(this.cpf) ? errors[0] = { msg: '', color: 'success', status: false } : errors[0] = { msg: "CPF inválido!", color: 'error', status: true };
			}
			return errors;
		},
	},
	methods: {
		fnLink() {
			// Cargo/função não é mais usado como regra de permissão.
			// Quem acessa a tela de Colaboradores pode escolher qualquer função.
			this.cargos = [
				{ text: 'Administrador', value: 'Admin' },
				{ text: 'Auxiliar Admin', value: 'Auxiliar Admin' },
				{ text: 'Auxiliar Eletricista', value: 'Auxiliar Eletricista' },
				{ text: 'Auxiliar Tecnico', value: 'Auxiliar Tecnico' },
				{ text: 'Coordenador', value: 'Coordenador' },
				{ text: 'Eletricista', value: 'Eletricista' },
				{ text: 'Estoquista', value: 'Estoquista' },
				{ text: 'Financeiro', value: 'Financeiro' },
				{ text: 'Gerente', value: 'Gerente' },
				{ text: 'Operador Caixa', value: 'Operador Caixa' },
				{ text: 'Supervisor', value: 'Supervisor' },
				{ text: 'Vendedor', value: 'Vendedor' },
				]
		},
		onChangeCargaHoraria(valor) {
			if (valor === 'integral') {
				this.usuario.carga_horaria = 8
				this.cargaHorariaManual = null
			} else if (valor === 'meio_periodo') {
				this.usuario.carga_horaria = 4
				this.cargaHorariaManual = null
			} else if (valor === 'manual') {
				this.usuario.carga_horaria = this.cargaHorariaManual != null && this.cargaHorariaManual !== ''
				? parseInt(this.cargaHorariaManual, 10)
				: null
			}
		},
		definirTipoCargaHoraria(valor) {
			const carga = Number(valor)

			if (carga === 8) {
				this.tipoCargaHoraria = 'integral'
				this.cargaHorariaManual = null
			} else if (carga === 4) {
				this.tipoCargaHoraria = 'meio_periodo'
				this.cargaHorariaManual = null
			} else if (!Number.isNaN(carga) && valor !== null && valor !== undefined && valor !== '') {
				this.tipoCargaHoraria = 'manual'
				this.cargaHorariaManual = carga
			} else {
				this.tipoCargaHoraria = 'integral'
				this.cargaHorariaManual = null
				this.usuario.carga_horaria = 8
			}
		},
		normalizarCargaHorariaAntesDeSalvar() {
			if (this.tipoCargaHoraria === 'integral') {
				this.usuario.carga_horaria = 8
				return true
			}

			if (this.tipoCargaHoraria === 'meio_periodo') {
				this.usuario.carga_horaria = 4
				return true
			}

			const manual = Number(this.cargaHorariaManual)

			if (!Number.isInteger(manual) || manual < 5) {
				this.usuario.carga_horaria = null
				this.$toasted.show('Informe uma carga horaria inteira a partir de 5 horas.', { type: 'danger', duration: 4000 })
				return false
			}

			this.usuario.carga_horaria = manual
			return true
		},
		validarCargaHorariaManual(valor) {
			if (this.tipoCargaHoraria !== 'manual') return true
			const carga = Number(valor)
			return (Number.isInteger(carga) && carga >= 5) || 'Informe horas inteiras a partir de 5'
		},
		async loadUser(item, modo = 'save') {
			try {
				this.mode = modo
				this.usuario = item ? {
					id_user: item.idusuarios,
					nome: item.nome,
					usuario: item.usuario,
					email: item.email,
					cpf: item.cpf,
					nascimento: item.nascimento,
					cod_vendedor: item.cod_vendedor,
					cod_pdv: item.cod_pdv,
					contato: item.contato,
					carga_horaria: item.carga_horaria,
					tipo: item.tipo,
					id_func: item.idfuncionarios,
					salario: item.salario,
					externo: item.externo === 1,
					acesso_desktop: item.acesso_desktop === 1,
					carga_horaria_vigencia_inicio: new Date().toISOString().slice(0, 10),
				} : {
					tipo: 'Vendedor',
					externo: false,
					acesso_desktop: false,
					carga_horaria: 8,
					carga_horaria_vigencia_inicio: new Date().toISOString().slice(0, 10)
				}

				this.definirTipoCargaHoraria(this.usuario.carga_horaria)
				this.dialog = true

			} catch (e) {
				showError(e)
			}
		},
		save() {
			if (!this.normalizarCargaHorariaAntesDeSalvar()) 
				return

			const metodo = this.usuario.id_user ? 'put' : 'post'
			const id = this.usuario.id_user ? `/${this.usuario.id_user}` : ''

			axios[metodo](`${baseApiUrl}/usuarios${id}`, this.usuario).then(() => {
				this.$toasted.global.defaultSuccess()
				Bus.$emit('reload')
				this.reset()
			})
			.catch(showError)
		},
		remove() {
			const id = this.usuario.id_user
			axios.delete(`${baseApiUrl}/usuarios/${id}`)
			.then(() => {
				this.$toasted.global.defaultSuccess()
				Bus.$emit('reload')
				this.reset()
			})
			.catch(showError)
		},
		reset() {
			try {
				this.dialog = false
				this.usuario = {}
				this.tipoCargaHoraria = 'integral'
				this.cargaHorariaManual = null
			} catch (e) {
				showError(e)
			}
		},
		isEmailValid() {
			return (this.reg.test(this.usuario.email)) ? true : 'Email inválido!!'
		},
	},
	mounted() {
		this.fnLink()
		Bus.$on('loadUser', (item, modo) => {
			this.loadUser(item, modo)
		})
	}
}
</script>


<style lang="css" scoped></style>
